import { Components, Theme } from '@mui/material';

import palette from '../baseTheme/palette';

export const MuiButton: Components<Theme>['MuiButton'] = {
  variants: [
    {
      props: { variant: 'flat' },
      style: {
        background: '#000',
        border: 'none',
        color: 'rgba(255, 255, 255, 0.72)',
        '& svg': {
          color: palette.primary.main,
        },
      },
    },
  ],
  styleOverrides: {
    root: {
      textTransform: 'none',
    },
    outlined: {
      position: 'relative',
      overflow: 'hidden',

      '&.Mui-disabled': {
        opacity: 0.4,
      },
    },
    sizeMedium: {
      padding: '7px 22px',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.01em',
      borderRadius: '8px',
    },
    sizeLarge: {
      paddingLeft: 24,
      paddingRight: 24,
      height: 56,
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.01em',
      borderRadius: '8px',
    },
  },
};
